import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const ServiceErrorDialog = ({ open, onConfirm }) => {
  return (
    <Dialog
      open={open}
      maxWidth='xs'
      fullWidth
      disableEscapeKeyDown
      disableBackdropClick
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WarningAmberIcon color='warning' sx={{ fontSize: 24 }} />
          <Typography
            variant='h6'
            component='div'
            sx={{ fontWeight: 600, color: "warning.main" }}
          >
            Service temporarily unavailable
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant='body1' color='text.secondary' sx={{ mt: 1 }}>
          "We’re having trouble connecting. Retrying..."
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onConfirm}
          variant='contained'
          color='primary'
          fullWidth
          sx={{
            borderRadius: 1,
            textTransform: "none",
            px: 3,
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
              backgroundColor: "primary.dark",
            },
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceErrorDialog;
